module.exports = __webpack_public_path__ + "e5ba8e96b6895599639e34cf440ff554.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/dtg.jpg
// module id = 782
// module chunks = 0